import script from "./SelectAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectAccount.vue?vue&type=script&setup=true&lang=ts"

import "./SelectAccount.vue?vue&type=style&index=0&id=48481d8e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48481d8e"]])

export default __exports__